var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-badge",style:({ backgroundColor: _vm.statusInfo ? _vm.statusInfo.color : '#f00' })},[(_vm.statusInfo)?_c('span',[_vm._v(" "+_vm._s(_vm.statusInfo.name)+" ")]):_c('span',[_vm._v("----")])])}
var staticRenderFns = []

export { render, staticRenderFns }